import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NotificationItem from './NotificationItem';
import { REACT_APP_API_NOTIFICATIONS } from '../../utils/constants';

const Notifications = () => {
    const { notificationId } = useParams();
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                setLoading(true);
                const response = await fetch(REACT_APP_API_NOTIFICATIONS);
                if (response.ok) {
                    const data = await response.json();
                    setNotifications(data);
                }
            } catch (error) {
                console.error('Error fetching notifications:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchNotifications();
    }, [notificationId]);

    return (
        <div className="content ht-100v pd-0">
            <div className="content-body">
                <div className="container pd-x-0 pd-lg-x-10 pd-xl-x-0">
                    <div className="flex items-center justify-between mg-b-20 mg-lg-b-30">
                        <div>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                    <li className="breadcrumb-item">
                                        <a href="/clients">Clients</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Notifications
                                    </li>
                                </ol>
                            </nav>
                            <h4 className="mg-b-0 tx-spacing--1">Notifications</h4>
                        </div>
                    </div>

                    {loading ? (
                        <div className="flex justify-center items-center" style={{ height: '200px' }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : notifications.length > 0 ? (
                        notifications.map((notification, index) => (
                            <NotificationItem
                                key={notification.id || index}
                                {...notification}
                            />
                        ))
                    ) : (
                        <div className="card">
                            <div className="card-body pd-20 pd-lg-25">
                                <p className="mg-b-0 tx-14 text-center">No notifications found.</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Notifications;
